export const benefits = [
  {
    icon: "ri-search-eye-line",
    title: "Product Discovery",
    description: "Find profitable products faster with structured product lists and trending item databases. Stop wasting hours on manual searching.",
  },
  {
    icon: "ri-store-2-line",
    title: "Supplier Research",
    description: "Compare different China suppliers side by side. Evaluate quality, pricing, and reliability before committing to any purchase.",
  },
  {
    icon: "ri-line-chart-line",
    title: "Price Analysis",
    description: "Track product costs across multiple suppliers. Identify the best deals and maximize your profit margins with data-driven decisions.",
  },
  {
    icon: "ri-folders-line",
    title: "Shopping Organization",
    description: "Manage hundreds of products easily in one central spreadsheet. Keep track of orders, shipments, and inventory without the chaos.",
  },
];

export const comparisonData = [
  { feature: "Product Finding", traditional: "Manual browsing, random discovery", spreadsheet: "Organized product database, quick filters" },
  { feature: "Supplier Comparison", traditional: "Scattered notes, no structure", spreadsheet: "Side-by-side supplier evaluation" },
  { feature: "Price Tracking", traditional: "Memory or basic notes", spreadsheet: "Systematic price history and trends" },
  { feature: "Shipping Calculation", traditional: "Manual estimation per order", spreadsheet: "Built-in formulas and weight tracking" },
  { feature: "Time Efficiency", traditional: "Hours per research session", spreadsheet: "Minutes with pre-built templates" },
  { feature: "Beginner Friendly", traditional: "Steep learning curve", spreadsheet: "Copy-paste ready, instant start" },
];

export const securityData = [
  { area: "User Privacy", protection: "We collect no personal data beyond basic analytics. Your browsing is completely anonymous." },
  { area: "Website Safety", protection: "SSL encrypted connection ensures all data transmitted is secure and protected from interception." },
  { area: "External Links", protection: "All outgoing links are clearly marked. We link only to verified and reputable websites." },
  { area: "Content Accuracy", protection: "Our content is regularly reviewed and updated to reflect the latest information and market conditions." },
];